import { render, staticRenderFns } from "./CancelledPage.vue?vue&type=template&id=6884c4ae&scoped=true&"
import script from "./CancelledPage.vue?vue&type=script&lang=js&"
export * from "./CancelledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884c4ae",
  null
  
)

export default component.exports